export default "__VITE_ASSET__CkvSqhxR__"